:host {
  display: block;
}

.article-name {
  margin-bottom: var(--cms-spacing-100);
  font-weight: var(--cms-heading-base-font-weight);
  font-size: var(--cms-font-size-112);
  line-height: var(--cms-line-height-150);
  font-family: var(--cms-brandfont2), serif;
}

.article-id {
  font-weight: var(--cms-base-font-weight);
  font-style: italic;
  margin-bottom: var(--cms-spacing-075);
  font-size: var(--cms-font-size-087);
  color: var(--cms-semanticColors-base-medium-text);
}